import { useState } from "react";
import { Progress } from "reactstrap";

const useProgressBar = () => {
    const [progressValue, setProgressValue] = useState(0);

    const startProgress = () => {
        Array(8)
            .fill(0)
            .forEach((_, index) =>
                setTimeout(
                    () => setProgressValue((index + 1) * 10),
                    (index + 1) * 200
                )
            );
    };

    const finishProgress = () => {
        setProgressValue(100);
    };

    const ProgressBar = () =>
        progressValue ? (
            <div
                className="progress-container progress-success"
                style={{ width: "300px" }}
            >
                <div className="d-flex justify-content-between">
                    <span className="progress-badge">Uploading Image</span>
                    <small className="text-white">{progressValue}</small>
                </div>

                <Progress max="100" value={progressValue}></Progress>
            </div>
        ) : (
            <></>
        );

    return [ProgressBar, startProgress, finishProgress];
};

export default useProgressBar;
